import React from 'react';
import PropTypes from "prop-types";
import FontAwesome from 'react-fontawesome';

import AdminTitle from '../../components/AdminTitle';
import Button from '../../components/Button';
import Api, { Utils } from '../../Api';

import './SingleOrder.less';

let orderItemStates = [
  'WAITING_ON_ORDER',
  'CANCELED',
  'WAITING_ON_SHIPPING',
  'SHIPPED',
  'DELIVERED',
  'RETURN_REQUESTED',
  'RETURNED',
  'BACKORDERED'
];

let shippingProviders = {
  'default': 'None',
  'canada_post': 'Canada Post',
  'dhl_ecommerce': 'DHL eCommerce',
  'dhl_express': 'DHL Express',
  'fedex': 'FedEx',
  'purolator': 'Purolator',
  'ups': 'UPS',
  'usps': 'USPS'
};

function findByToken(token, list) {
  return list.find((item) => {
    return item.token === token;
  });
}

export default class SingleOrder extends React.Component {
  constructor(props) {
    super(props);

    Utils.bindThis(
      this,
      [
        'checkItem',
        'clearChecked',
        'onOrderItemChanged',
        'onOrderItemUpdate',
        'onOrderItemCancelEditing',
        'updateOrderItem',
        'cancelItems',
        'removeItems',
        'newShipment',
        'updateBrandOrder',
        'createOrUpdateShipment',
        'removeShipment',
        'getProducts',
        'getBrandOrders',
        'getShipments',
        'getPayments'
      ]
    );

    this.state = {
      editingItem: null,
      order: null,
      orders: null,
      checkedItems: []
    };
  }

  componentWillMount() {
    this.reloadOrder();
  }

  reloadOrder() {
    return Api.getOrder(this.props.params.orderToken).then(
      (ordersResponse) => {
        this.setState({
          order: ordersResponse.orders[0],
          orders: ordersResponse,
          checkedItems: []
        });
      });
  }

  clearChecked() {
    this.setState({checkedItems: []});
  }

  checkItem(event) {
    let items = Utils.clone(this.state.checkedItems);
    if (event.target.checked) {
      items.push(event.target.value);
    } else {
      items = items.filter((item) => {
        return item !== event.target.value;
      });
    }

    this.setState({checkedItems: items});
  }

  cancelItems() {
    return Api.cancelOrderItems(this.state.order.token, this.state.checkedItems)
      .then(
        () => {
          return this.reloadOrder();
        },
        (error) => {
          alert(error.response.message);
        }
      );
  }

  removeItems() {
    return Api.removeOrderItems(this.state.order.token, this.state.checkedItems)
      .then(
        () => {
          return this.reloadOrder();
        },
        (error) => {
          alert(error.response.message);
        }
      );
  }

  onEditOrderItemClick(item) {
    let editingItem = {
      'token': item.token,
      'brand_token': item.brand_token,
      'name': item.name,
      'state': item.state,
      'expected_ship_date': item.expected_ship_date,
      'price_cents': item.price_cents,
      'quantity': item.quantity
    };

    this.setState({
      editingItem: editingItem
    });
  }

  onOrderItemChanged(event) {
    let editingItem = Utils.clone(this.state.editingItem);

    let fieldName = event.target.name;
    if (fieldName === 'expected_ship_date') {
      editingItem['shipDate'] = event.target.value;
    } else {
      editingItem[fieldName] = event.target.value;
    }

    this.setState({editingItem: editingItem});
  }

  onOrderItemUpdate() {
    let editingItem = this.state.editingItem;
    if (editingItem.shipDate && editingItem.shipDate !== '') {
      editingItem.expected_ship_date = new Date(editingItem.shipDate).getTime();
    }
    editingItem.shipDate = null;
    return Api.updateOrderItem(this.state.order.token, editingItem).then(
      () => {
        this.onOrderItemCancelEditing();
        return this.reloadOrder();
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  updateOrderItem(orderItem) {
    let payload = orderItem;
    if (orderItem.shipDate && orderItem.shipDate !== '') {
      payload.expected_ship_date = new Date(orderItem.shipDate).getTime();
    }

    delete payload.shipDate;

    return Api.updateOrderItem(this.state.order.token, payload).then(
      () => {
        return this.reloadOrder();
      },
      error => {
        console.error(error);
        alert(error.response.message);
      }
    );
  }

  onOrderItemCancelEditing() {
    this.setState({
      editingItem: null
    });
  }

  updateBrandOrder(brandOrder) {
    let returnValue = Api.updateBrandOrder(this.state.order.token, brandOrder);
    returnValue.then(
      () => {
        return this.reloadOrder();
      }
    );

    return returnValue;
  }

  newShipment() {
    let order = this.state.order;
    let newShipment = {
      order_token: order.token,
      order_item_tokens: this.state.checkedItems
    };
    if (order.shipments) {
      order.shipments.push(newShipment);
    } else {
      order.shipments = [newShipment];
    }
    this.setState({order});
  }

  createOrUpdateShipment(data) {
    let payload = Utils.clone(data);
    payload.order_token = this.state.order.token;
    let returnValue = Api.updateShipment(payload);

    returnValue.then(
      () => {
        return this.reloadOrder();
      }
    );

    return returnValue;
  }

  removeShipment(shipmentToken) {
    let orderToken = this.state.order.token;
    Api.removeShipment(orderToken, shipmentToken).then(
      () => {
        return this.reloadOrder();
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  getProducts() {
    let previousBrand = null;

    return this.state.order.items.map((orderItem) => {
      // This is needed by the BrandOrder class
      orderItem.product = this.state.orders.products[orderItem.product_token];
      let brand = this.state.orders.brands[orderItem.brand_token];
      let showBrandName = orderItem.brand_token !== previousBrand;
      previousBrand = orderItem.brand_token;

      return (
        <OrderItemLine
          checked={this.state.checkedItems.indexOf(orderItem.token) >= 0}
          onCheck={this.checkItem}
          key={orderItem.token}
          orderItem={orderItem}
          brand={brand}
          showBrandName={showBrandName}
          updateOrderItem={this.updateOrderItem}
        />
      );
    });
  }

  getBrandOrders() {
    if (!this.state.order.brand_orders || this.state.order.brand_orders.length <= 0) {
      return (<div>no brand orders</div>);
    }

    return this.state.order.brand_orders.map((brandOrder) => {
      return (
        <BrandOrder
          key={brandOrder.token}
          brandOrder={brandOrder}
          items={this.state.order.items}
          updateBrandOrder={this.updateBrandOrder}
        />
      );
    });
  }

  getShipments() {
    if (!this.state.order.shipments || this.state.order.shipments.length <= 0) {
      return (<div>no shipments</div>);
    }

    return this.state.order.shipments.map((shipment, index) => {
      return (
        <Shipment
          key={shipment.token || ('new-shipment-' + index)}
          shipment={shipment}
          createOrUpdateShipment={this.createOrUpdateShipment}
          removeShipment={this.removeShipment}
          items={this.state.order.items}
        />
      );
    });
  }

  getPayments() {
    if (!this.state.order.payments || this.state.order.payments.length <= 0) {
      return (<div>no payments</div>);
    }
  }

  render() {
    if (this.state.order === null) {
      return (<FontAwesome name="refresh" spin />)
    } else if (this.state.order === null) {
      return (<div>Invalid order</div>);
    }

    let retailer = findByToken(this.state.order.retailer_token, this.state.orders.retailers) || {};
    let user = findByToken(this.state.order.user_token, this.state.orders.users) || {};

    // Cancel or Remove items button check
    let cancelOrRemoveItemsEnabled = this.state.checkedItems.length > 0;
    this.state.checkedItems.forEach((itemToken) => {
      let orderItem = findByToken(itemToken, this.state.order.items);
      if (!orderItem) {
        console.error('Cannot find item %s in order.', itemToken);
        return;
      }

      if (orderItem.state !== 'WAITING_ON_SHIPPING'
        && orderItem.state !== 'WAITING_ON_ORDER'
        && orderItem.state !== 'SHIPPED' // We allow cancelling if not yet shipped!
        && orderItem.state !== 'CANCELED') {
        cancelOrRemoveItemsEnabled = false;
      }
    });

    // Shipment button check
    let createShipmentEnabled = this.state.checkedItems.length > 0;
    this.state.checkedItems.forEach((itemToken) => {
      let orderItem = findByToken(itemToken, this.state.order.items);
      if (!orderItem) {
        console.error('Cannot find item %s in order.', itemToken);
        return;
      }

      if (orderItem.state !== 'WAITING_ON_SHIPPING') createShipmentEnabled = false;
    });

    return (
      <div className="single-order-component">
        <AdminTitle title={retailer.name + ' (' + this.state.order.token +')'} />
        <dl>
          <dt>Order Status</dt>
          <dd>{this.state.order.state}</dd>

          <dt>User</dt>
          <dd>{user.name}</dd>

          <dt>Retailer</dt>
          <dd>{retailer.name}</dd>
        </dl>
        <div className="products-list">
          <h4>Products</h4>
          <div>
            {this.getProducts()}
          </div>
          <div className="button-group">
            <Button disabled={!cancelOrRemoveItemsEnabled} onClick={this.cancelItems}>Cancel Items</Button>
            <Button disabled={!cancelOrRemoveItemsEnabled} onClick={this.removeItems}>Remove Items</Button>
            <Button disabled={!createShipmentEnabled} onClick={this.newShipment}>Create Shipment</Button>
            <Button disabled={this.state.checkedItems.length === 0} onClick={this.clearChecked}>Uncheck Everything</Button>
          </div>
        </div>
        <div className="brand-orders">
          <h4>Brand Orders</h4>
          <div>
            {this.getBrandOrders()}
          </div>
        </div>
        <div className="shipment-list">
          <h4>Shipments</h4>
          <div>
            {this.getShipments()}
          </div>
        </div>
        <div className="payment-list">
          <h4>Payments</h4>
          <div>
            {this.getPayments()}
          </div>
          <div className="button-group">
            <Button>Add Payment</Button>
          </div>
        </div>
        <dl>
          <dt>Order total</dt>
          <dd>${Utils.formatCents(this.state.order.total_amount_cents)}</dd>
        </dl>
      </div>
    );
  }
}

/* Dedicated class for Brand Orders. They need functions from the SingleOrder class. */
class BrandOrder extends React.Component {
  constructor(props) {
    super(props);

    Utils.bindThis(this, [
      'onCommissionChange',
      'onExternalTokenChange',
      'onNotesChange',
      'onUpdate',
      'startEditing',
      'cancelEditing'
    ]);

    this.state = {
      editing: false,
      commission: props.brandOrder.commission_bps ? props.brandOrder.commission_bps / 100 + '' : '',
      externalToken: props.brandOrder.external_token || '',
      notes: props.brandOrder.notes || ''
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      commission: nextProps.brandOrder.commission_bps ? nextProps.brandOrder.commission_bps / 100 + '' : '',
      externalToken: nextProps.brandOrder.external_token || '',
      notes: nextProps.brandOrder.notes || ''
    });
  }

  startEditing() {
    this.setState({
      editing: true
    });
  }

  cancelEditing() {
    this.setState({
      editing: false,
      commission: this.props.brandOrder.commission_bps ? this.props.brandOrder.commission_bps / 100 + '' : '',
      externalToken: this.props.brandOrder.external_token || '',
      notes: this.props.brandOrder.notes || ''
    });
  }

  onCommissionChange(event) {
    this.setState({
      commission: event.target.value
    });
  }

  onExternalTokenChange(event) {
    this.setState({
      externalToken: event.target.value
    });
  }

  onNotesChange(event) {
    this.setState({
      notes: event.target.value
    });
  }

  onUpdate() {
    let brandOrder = this.props.brandOrder;
    brandOrder.commission_bps = parseInt(parseFloat(this.state.commission) * 100, 10);
    brandOrder.external_token = this.state.externalToken;
    brandOrder.notes = this.state.notes;

    return this.props.updateBrandOrder(brandOrder)
      .then(() => {
        this.setState({
          editing: false
        });
      });
  }

  render() {
    let brandOrder = this.props.brandOrder;
    let items = this.props.items;

    let products = brandOrder.order_item_tokens
      .map((orderItemToken) => {
        let productOption = findByToken(orderItemToken, items);

        if (!productOption) {
          console.error('No product option for token %s', orderItemToken);
          console.error(brandOrder);
          return orderItemToken;
        }

        return productOption.product.name;
      })
      .join(', ');

    let brandOrderDetails;
    if (this.state.editing === true) {
      brandOrderDetails =
        <span>
          <input
            placeholder="Commission %"
            className="input"
            type="text"
            value={this.state.commission}
            onChange={this.onCommissionChange}
          />
          <input
            placeholder="external token"
            className="input"
            type="text"
            value={this.state.externalToken}
            onChange={this.onExternalTokenChange}
          />
          <input
            placeholder="notes"
            className="input"
            type="text"
            value={this.state.notes}
            onChange={this.onNotesChange}
          />
          <span className="button-group">
            <Button onClick={this.onUpdate}>Update</Button>
            <Button onClick={this.cancelEditing}>Cancel</Button>
          </span>
        </span>;
    } else {
      brandOrderDetails =
        <span>
          <h5 className="inline">Commission %</h5>
          <span>{ this.state.commission ? this.state.commission : `<empty>` }</span>
          <h5 className="inline">External Token</h5>
          <span>{ this.state.externalToken ? this.state.externalToken : '<empty>' }</span>
          <h5 className="inline">Notes</h5>
          <span>{ this.state.notes ? this.state.notes : `<empty>` }</span>
          <FontAwesome className="icon-button" onClick={this.startEditing} name="pencil" />
        </span>;
    }

    return (
      <div className="brand-order-item">
        <span className="product-names">{products}</span>
        <span className="form brand-order">{brandOrderDetails}</span>
      </div>
    );
  }
}

class Shipment extends React.Component {
  constructor(props) {
    super(props);

    Utils.bindThis(this, [
      'onChange',
      'onUpdate',
      'onRemove',
      'startEditing',
      'cancelEditing',
      'getContents'
    ]);

    this.state = {
      editing: !props.shipment.token, // If we don't have a token, we are creating this shipment. Start on edit mode.
      trackingCode: props.shipment.tracking_code || '',
      costDollars: Utils.formatCents(props.shipment.cost_cents) || '',
      provider: props.shipment.provider || 'default'
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      trackingCode: nextProps.shipment.tracking_code || '',
      costDollars: Utils.formatCents(nextProps.shipment.cost_cents) || '',
      provider: nextProps.shipment.provider || 'default'
    });
  }

  onRemove() {
    this.props.removeShipment(this.props.shipment.token);
  }

  startEditing() {
    this.setState({
      editing: true
    });
  }

  cancelEditing() {
    this.setState({
      editing: false,
      trackingCode: this.props.shipment.tracking_code || '',
      costDollars: Utils.formatCents(this.props.shipment.cost_cents) || '',
      provider: this.props.shipment.provider || 'default',
    });
  }

  onChange(event) {
    let payload = {};
    payload[event.target.name] = event.target.value;

    this.setState(payload);
  }

  onUpdate() {
    let trackingCode = this.state.trackingCode.trim();

    if (trackingCode.length > 0 && trackingCode.length < 5) {
      alert('Tracking costs must have at least 5 characters');
      return;
    }

    if (trackingCode.length > 4 && this.state.provider === 'default') {
      // Note that we allow picking a provider without setting a tracking code.
      alert('You must selected a valid provider when entering a tracking code');
      return;
    }

    let validTracking = trackingCode.length > 0 && this.state.provider !== 'default';

    let shipment = this.props.shipment;
    shipment.tracking_code = validTracking ? trackingCode : null;
    shipment.cost_cents = this.state.costDollars.length > 0 ? Utils.dollarToCents(this.state.costDollars) : null;
    shipment.provider = this.state.provider === 'default' ? null : this.state.provider;

    if (!shipment.cost_cents) {
      alert('Shipment must have cost. Set it to ZERO to if you wish to make it free!');
      return;
    }

    this.setState({error: null});

    return this.props.createOrUpdateShipment(shipment)
      .then(() => {
        this.setState({
          editing: false
        });
      })
      .catch(error => {
        alert('Error: ' + error);
      });
  }

  getContents(editing, canRemove) {
    let contents = null;
    if (editing) {
      contents = [
        <span key={`${this.props.shipment.token}-order-admin-external-token`} className="external-token">
          <h5 className="inline">Tracking Code</h5>
          <input
            placeholder="tracking code"
            className="input"
            type="text"
            name="trackingCode"
            value={this.state.trackingCode}
            onChange={this.onChange}
          />
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-shipping-cost`} className="shipping-cost">
          <h5 className="inline">Shipping Cost</h5>
          <input
            type="text"
            className="input"
            placeholder="shipping cost"
            name="costDollars"
            value={this.state.costDollars}
            onChange={this.onChange}
           />
        </span>,
        <span key={`${this.props.shipment.provider}-order-admin-shipping-provider`} className="shipping-provider">
          <h5 className="inline">Shipping Provider</h5>
          <select
            value={this.state.provider}
            onChange={this.onChange}
            className="input"
            name="provider">
              {Object.keys(shippingProviders).map((provider) => {
                return (<option key={`${this.props.shipment.token}-provider-${provider}`}
                                value={provider}>{shippingProviders[provider]}</option>);
              })}
            </select>
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-shipping-button-group`} className="button-group">
          <Button onClick={this.onUpdate}>{this.props.shipment.token ? 'Update' : 'Create'}</Button>
          <Button onClick={this.cancelEditing}>Cancel</Button>
        </span>,
        <div key={`${this.props.shipment.token}-order-admin-shipping-error`} className="error">{this.state.error ? 'something went wrong. check console.' : null}</div>
      ];
    } else {
      contents = [
        <span key={`${this.props.shipment.token}-order-admin-shipped-at`} className="shipped-at">
          <h5 className="inline">Shipped at</h5>
          <span>{ this.props.shipment.shipped_at ? Utils.millisToYMD(this.props.shipment.shipped_at) : 'N/A' }</span>
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-delivered-at`} className="delivered-at">
          <h5 className="inline">Delivered at</h5>
          <span>{ this.props.shipment.delivered_at ? Utils.millisToYMD(this.props.shipment.delivered_at) : 'N/A' }</span>
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-external-token`} className="external-token">
          <h5 className="inline">Tracking Code</h5>
          <span>{ this.state.trackingCode ? this.state.trackingCode : 'N/A' }</span>
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-shipping-cost`} className="shipping-cost">
          <h5 className="inline">Shipping Cost</h5>
          <span>{ this.state.costDollars ? ('$' + this.state.costDollars) : 'N/A' }</span>
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-shipping-provider`} className="shipping-provider">
          <h5 className="inline">Shipping Provider</h5>
          <span>{ this.state.provider ? shippingProviders[this.state.provider] : 'N/A' }</span>
        </span>,
        <span key={`${this.props.shipment.token}-order-admin-shipping-button-group`}>
          <FontAwesome className="icon-button" onClick={this.startEditing} name="pencil" />
        </span>
      ];

      if (canRemove) {
        contents.push(
          <span key={`${this.props.shipment.token}-order-admin-shipping-remove-button-group`}>
            <FontAwesome className="icon-button" onClick={this.onRemove} name="remove" />
          </span>
        );
      }
    }
    return <span className="form">{contents}</span>;
  }

  render() {
    let shipment = this.props.shipment;
    let items = this.props.items;
    let canRemove = !shipment.shipped_at;

    let products = shipment.order_item_tokens
      .map((orderItemToken) => {
        let productOption = findByToken(orderItemToken, items);

        if (!productOption) {
          console.error('No product option for token %s', orderItemToken);
          console.error(shipment);
          return orderItemToken;
        }

        return productOption.product.name;
      })
      .join(', ');

    return (
      <div className="shipment-item">
        <span className="product-names">{products}</span>
        {this.getContents(this.state.editing, canRemove)}
      </div>
    );
  }
}

class OrderItemLine extends React.Component {
  static propTypes = {
    orderItem: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
    showBrandName: PropTypes.bool,
    checked: PropTypes.bool,
    onCheck: PropTypes.func.isRequired,
    updateOrderItem: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.startEditing = this.startEditing.bind(this);
    this.finishEditing = this.finishEditing.bind(this);
    this.saveItem = this.saveItem.bind(this);

    this.state = {
      editing: false
    };
  }

  startEditing() {
    this.setState({
      editing: true
    });
  }

  finishEditing() {
    this.setState({
      editing: false
    });
  }

  saveItem() {
    let payload = Utils.getFormValues(
      this,
      [
        "state",
        "expected_ship_date",
        "quantity",
        "price_cents"
      ]
    );

    payload.token = this.props.orderItem.token;
    payload.expected_ship_date = new Date(payload.expected_ship_date).getTime();

    let returnValue = this.props.updateOrderItem(payload);
    returnValue.then(this.finishEditing);
    return returnValue;
  }

  render() {
    let orderItem = this.props.orderItem;
    let product = orderItem.product;
    let brand = this.props.brand;
    let brandLine;

    if (this.props.showBrandName) {
      brandLine = <div className="brand-name">{ brand ? brand.name : orderItem.brand_token }</div>;
    }

    if (this.state.editing) {
      if (!orderItem.shipDate) {
        if (orderItem.expected_ship_date) {
          orderItem.shipDate = Utils.millisToYMD(orderItem.expected_ship_date);
        } else {
          orderItem.shipDate = '';
        }
      }

      let orderItemStatesOptions = orderItemStates.map(state => {
          return <option key={`${orderItem.token}-state-${state}`} value={state}>{state}</option>;
        });

      return (
        <div>
          {brandLine}
          <div className="product-line">
            <span className="product-name">{product.name}</span>
            <span key={`${orderItem.token}-order-admin-order-item-state`} className="order-item-state">
              <h5 className="inline">State</h5>
              <select
                defaultValue={orderItem.state}
                className="input"
                ref="state"
                name="state">{orderItemStatesOptions}</select>
            </span>
            <span key={`${orderItem.token}-order-admin-order-expected-ship-date`} className="order-item-expected-ship-date">
              <h5 className="inline">Expected ship date</h5>
              <input
                type="date"
                className="input"
                placeholder="Expected Shipping Date"
                name="expected_ship_date"
                ref="expected_ship_date"
                defaultValue={orderItem.shipDate}
              />
            </span>
            <span key={`${orderItem.token}-order-admin-order-item-quantity`} className="order-item-quantity">
              <h5 className="inline">Quantity</h5>
              <input
                type="text"
                className="input"
                placeholder="quantity"
                name="quantity"
                ref="quantity"
                defaultValue={orderItem.quantity}
              />
            </span>
            <span key={`${orderItem.token}-order-admin-order-item-price`} className="order-item-price">
              <h5 className="inline">Price Cents</h5>
              <input
                type="text"
                className="input"
                placeholder="price_cents"
                name="price_cents"
                ref="price_cents"
                defaultValue={orderItem.price_cents}
              />
            </span>
            <span key={`${orderItem.token}-order-admin-order-item-button-group`} className="button-group">
              <Button onClick={this.saveItem}>Update</Button>
              <Button onClick={this.finishEditing}>Cancel</Button>
            </span>
          </div>
        </div>
      );
    } else {
      let expectedShipDateSpan = null;
      if ((orderItem.state === 'WAITING_ON_SHIPPING' || orderItem.state === 'BACKORDERED') && orderItem.expected_ship_date) {
        let shipDate = Utils.millisToYMD(orderItem.expected_ship_date);
        expectedShipDateSpan = <span className="expected_ship-date">Ships by {shipDate}</span>
      }
      return (
        <div>
          {brandLine}
          <div className="product-line">
            <span>
              <input
                type="checkbox"
                value={orderItem.token}
                checked={this.props.checked}
                onChange={this.props.onCheck}
              />
            </span>
            <span className="product-name">{product.name}</span>
            <span className="state">{orderItem.state}</span>
            {expectedShipDateSpan}
            <span className="quantity">{orderItem.quantity} units</span>
            <span className="price">${Utils.formatCents(orderItem.price_cents)}</span>
            <span
              className="subtotal">
              Total: ${Utils.formatCents(orderItem.price_cents * orderItem.quantity)}
            </span>
            <span key={`${orderItem.token}-edit-order-item`}>
              <FontAwesome className="icon-button" onClick={this.startEditing} name="pencil"/>
            </span>
          </div>
        </div>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/SingleOrder.js
 **/